import React from 'react';
import { motion } from 'framer-motion';
import { UsersIcon } from 'lucide-react';
import { LOCATIONS } from '../../lib/locations';
import type { Vote } from '../../lib/types';
export function StatsCards({
  votes
}: {
  votes: Vote[];
}) {
  const total = votes.length;
  const counts = LOCATIONS.map(loc => ({
    loc,
    count: votes.filter(v => v.city === loc.city).length
  }));
  return <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-63" data-mp="1h9zx2j84gdh2">
      <motion.div layout className="col-span-2 flex items-center gap-4 rounded-3xl bg-gradient-to-br from-lavender-500 to-sky-500 p-5 text-white shadow-soft sm:col-span-3 lg:col-span-1" data-id="element-64" data-mp="1cbeyeo8iq1uq">
        <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/20" data-id="element-65" data-mp="1m1i1xid9my7b">
          <UsersIcon className="h-6 w-6" data-id="element-66" data-mp="200q2ofp2uedm" />
        </span>
        <span data-id="element-67" data-mp="201j3z159obod">
          <span className="block text-3xl font-700 tabular-nums leading-none" data-id="element-68" data-mp="1zywv8y6n3q4k">{total}</span>
          <span className="text-sm text-white/90" data-id="element-69" data-mp="1w18sxa2mav2n">Total Votes</span>
        </span>
      </motion.div>

      {counts.map(({
      loc,
      count
    }) => <motion.div key={loc.id} layout className="rounded-3xl bg-white p-5 shadow-soft" data-id="element-70" data-mp="26u1yyeo2799v">
          <span className="text-2xl" data-id="element-71" data-mp="2bswt2crh8k9a">{loc.emoji}</span>
          <span className="mt-2 block text-3xl font-700 tabular-nums leading-none text-slate-800" data-id="element-72" data-mp="2gsrg2584spp2">
            {count}
          </span>
          <span className={`text-sm font-600 ${loc.accent}`} data-id="element-73" data-mp="2lqt474kezf7e">{loc.city}</span>
        </motion.div>)}
    </div>;
}